import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { LocalContext } from 'contexts/LocalContext';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { encryptURL } from 'utils/functions';
import { useModal } from 'components/Modals';
import DeleteModal from 'components/Modals/DeleteModal';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import Grid from 'components/Grid';
import Filter from './filter';

const Locais = () => {
  const rotina = 'Celocal';
  const titulo = 'Locais de Estoque';
  const navigate = useNavigate();
  const { openModal, closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { deleteGrid, exportPdf, exportXls } = useContext(GridContext);
  const { local, getLocal, getLoading } = useContext(LocalContext);
  const { control, getValues, reset } = useForm({
    defaultValues: local?.filter,
  });

  const loadGrid = (props) => {
    if (props?.replace) {
      reset();
    }
    getLocal({ ...props, rotina, filter: getValues() });
  };

  const options = [
    {
      name: 'Adicionar',
      icon: 'add',
      action: () => navigate('/app/Locais/Gerar'),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({ rotina, filter: getValues(), order: local?.order }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({ rotina, filter: getValues(), order: local?.order }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={local?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
    {
      name: 'Transferência',
      icon: 'sync',
      action: () => navigate('/app/Locais/Enderecos/Transferencia'),
    },
  ];

  const rowOptions = [
    {
      name: 'Editar',
      icon: 'edit',
      action: ({ row }) => navigate(`/app/Locais/Gerar/${encryptURL(row)}`),
    },
    {
      name: 'Deletar',
      icon: 'delete',
      action: ({ row }) =>
        openModal(
          <DeleteModal
            onSubmit={() =>
              deleteGrid({
                params: { rotina, id: row?.id },
                cb: () => {
                  loadGrid();
                  closeModal();
                },
              })
            }
          />
        ),
    },
    {
      name: 'Endereços de Estoque',
      icon: 'inventory',
      menu: true,
      action: ({ row }) => navigate(`/app/Locais/Enderecos/${encryptURL(row)}`),
    },
    {
      name: 'Ver Estoque',
      icon: 'map',
      menu: true,
      action: ({ row }) => {
        const params = { filial_id: row?.filial_id, celocal_id: row?.id };
        navigate(`/app/Estoque/${encryptURL(params)}`);
      },
    },
  ];

  return (
    <Container>
      <Header rotina={rotina} titulo={titulo} colunas={local?.colunas} />
      <Card>
        <Grid
          grid={local}
          options={options}
          rowOptions={rowOptions}
          control={control}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
          activeFilter={(getActiveFilter) => getActiveFilter(getValues())}
          FilterComponent={
            <Filter grid={local} control={control} drops={drops} />
          }
        />
      </Card>
    </Container>
  );
};

export default Locais;
